<template>
  <div class="tm-movable-audio" v-tm-move="moveObj">
    <slot />

    <tm-audio-ghost
      v-if="$data.showGhost"
      :audio="$props.audio"
      :point="$data.ghostPoint"
      :mode="$data.mode"
      :isInside="$data.isInside"
    />
  </div>
</template>

<script>
import moveAudioExternalMixin from './moveAudioExternal';
import tmMove from './tmMove';
import tmAudioGhost from '../indicator/tmAudioGhost.vue';
import { TimePoint } from 'v/Story/Timeline/api/grid';
import { AudioGhostMode } from 'v/Story/Timeline/api/model';

export default {
  name: 'tm-movable-audio',
  mixins: [moveAudioExternalMixin],
  directives: { tmMove },
  components: {
    tmAudioGhost,
  },

  props: {
    audio: { type: Object, required: true },
  },

  data() {
    return {
      dragEnabled: true,
      showGhost: false,
      ghostPoint: new TimePoint(),
      isInside: false,
      mode: AudioGhostMode.DEFAULT,
    };
  },
};
</script>
